import { render, staticRenderFns } from "./UserInfoTab.vue?vue&type=template&id=d4a42628"
import script from "./UserInfoTab.vue?vue&type=script&lang=js"
export * from "./UserInfoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports